import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  Divider,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

interface RegistrationSuccessDialogProps {
  open: boolean;
  onClose: () => void;
  companyId: number | null;
}

export const RegistrationSuccessDialog: React.FC<
  RegistrationSuccessDialogProps
> = ({ open, onClose, companyId }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          maxWidth: '600px',
          width: '90%',
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <CheckCircleIcon color="success" sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h5" component="h2" fontWeight="bold">
            企業登録申請完了
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Alert severity="success" sx={{ mb: 3 }}>
          企業登録申請を受け付けました。ありがとうございます。
        </Alert>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" gutterBottom>
            申請ID: <strong>#{companyId}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            上記申請IDは審査に関するお問い合わせの際に必要となりますので、控えておいてください。
          </Typography>
        </Box>

        <Alert severity="info" icon={<ScheduleIcon />}>
          <Typography variant="body2">
            <strong>審査について</strong>
            <br />
            管理者による審査を行い、3営業日程度で結果をメールでお知らせいたします。
            <br />
            承認後、すぐにサービスをご利用いただけます。
          </Typography>
        </Alert>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          fullWidth
          size="large"
          sx={{ fontWeight: 'bold' }}
        >
          ログインページに戻る
        </Button>
      </DialogActions>
    </Dialog>
  );
};
